import { render, staticRenderFns } from "./BannerPrincipal.vue?vue&type=template&id=9389cda0&scoped=true&lang=pug&"
import script from "./BannerPrincipal.vue?vue&type=script&lang=js&"
export * from "./BannerPrincipal.vue?vue&type=script&lang=js&"
import style0 from "./BannerPrincipal.vue?vue&type=style&index=0&id=9389cda0&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9389cda0",
  null
  
)

export default component.exports